import styled from "styled-components";
import {
  ButtonLabel,
  DisabledPrimaryButton,
  PrimaryButton,
} from "./Buttons";
import { descentSectionDivider } from "./DescentFaqSection";

export const DESCENT_APPLICATION_URL =
  "https://blocksurvey.io/the-descent-ehwspaxRTJuGIruoZJNViQ?v=o";

const TIER_BUTTON_LABELS = {
  Seduced: "Apply to be Seduced",
  Surrendered: "Apply to be Surrendered",
  Owned: "Apply to be Owned",
};

const INVITATION_ONLY_TIERS = new Set(["Subjugated", "Collared"]);

export const TierApplicationCta = ({ tierTitle }) => {
  const invitationOnly = INVITATION_ONLY_TIERS.has(tierTitle);
  const label = TIER_BUTTON_LABELS[tierTitle];

  if (!label && !invitationOnly) return null;

  return (
    <CtaWrap>
      {invitationOnly ? (
        <>
          <DisabledPrimaryButton>
            {tierTitle ? `Apply to be ${tierTitle}` : "Apply"}
          </DisabledPrimaryButton>
          <InvitationLegend>Invitation only</InvitationLegend>
        </>
      ) : (
        <ApplicationLink
          href={DESCENT_APPLICATION_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <PrimaryButton type="button">
            <ButtonLabel>{label}</ButtonLabel>
          </PrimaryButton>
        </ApplicationLink>
      )}
    </CtaWrap>
  );
};

export const DescentPageCtaSection = () => (
  <PageCtaSection>
    <PageCtaTitle>Does the depth call to you?</PageCtaTitle>
    <ApplicationLink
      href={DESCENT_APPLICATION_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <PrimaryButton type="button">
        <ButtonLabel>I&apos;m ready to descend</ButtonLabel>
      </PrimaryButton>
    </ApplicationLink>
  </PageCtaSection>
);

const ApplicationLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: inline-flex;
`;

const CtaWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  margin-top: 1.6rem;
`;

const InvitationLegend = styled.p`
  margin: 0;
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
`;

const PageCtaSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.5rem;
  margin: 6rem 0 7rem;
  padding: 5rem 2rem 6rem;
  ${descentSectionDivider}

  @media screen and (max-width: 600px) {
    gap: 3.5rem;
    margin: 4.5rem 0 5rem;
    padding: 3.5rem 1rem 4.5rem;
  }
`;

const PageCtaTitle = styled.h3`
  font-family: "Ysabeau";
  font-weight: 300;
  text-transform: none;
  font-size: 1.6rem;
  margin: 0;
  padding: 0 1.5rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
`;
